import { useSelector } from "react-redux";

export default function BookTableFooter({activeTab}) {
  const { stats, tables } = useSelector((state) => state.table.table);
  const totalGuests = tables.reduce((tableAcc, table) => {
    const tableGuests = table.bookings.reduce((bookingAcc, booking) => {
      return bookingAcc + (booking.guest || 0);
    }, 0);

    return tableAcc + tableGuests;
  }, 0);

  const seatPercentage =
    stats?.total_seats > 0
      ? Math.min((totalGuests / stats.total_seats) * 100, 100)
      : 0;

  const tablePercentage =
    stats?.total_table > 0
      ? Math.min((stats.free / stats.total_table) * 100, 100)
      : 0;

  return (
    <div className=" h-[40px] tab-max:h-[60px] -mb-2 tab-max:-mb-6 tab-max:mt-1 flex gap-5 px-7 text-gray-300 text-sm font-medium">
      <div className="w-56">
        <p>Tables: {stats?.free}/{stats?.total_table}</p>
        <div className="w-full bg-[#525355] rounded-full mt-1">
          <div className={`${activeTab === 'live'? 'bg-[#ffbb00]' : 'bg-gray-300'} h-2 tab-max:h-3 rounded-full`} style={{ width: `${tablePercentage}%` }}></div>
        </div>
      </div>
      <div className="w-56">
        Seats: {totalGuests}/{stats?.total_seats}
        <div className="w-full bg-[#525355] rounded-full mt-1">
          <div className={`${activeTab === 'live'? 'bg-[#ffbb00]' : 'bg-gray-300'} h-2 tab-max:h-3 rounded-full`} style={{ width: `${seatPercentage}%` }}></div>
        </div>
      </div>
    </div>
  );
}
